import { BaseModel } from '@/api/base-model'
import { Product } from '@/api/model/product'
import { OfferAPI } from '@/api/backend-client'

export class Offer extends BaseModel<Offer> {
    protected collectionName = OfferAPI.collectionName

    constructor(
        public id: string,
        public name: string,
        public description: string,
        public imageUrl: string,
        public url: string,
        public tags: string[],
        public products: Product[],
    ) { super(id) }

    static fromData(data: any): Offer {
        if (data === null || typeof data === 'string' || data instanceof Offer) {
            return data
        }

        return new Offer(
            data.id,
            data.name,
            data.description,
            data.imageUrl,
            data.url,
            data.tags,
            Object.values(data.products || {}).map(entry => Product.fromData(entry)),
        )
    }
}
